import { Component, OnInit, ViewChild, signal, model, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TermsAndConditionService } from '../services/terms-and-condition.service';
import { NgForm } from '@angular/forms';
// import { registerContentQuery } from '@angular/core/src/render3';
import { LineNotificationService } from '../services/line-notification.service';
import { Channel } from '../models/channel.model';
import { LoaderService } from '../services/loader.service';
import { Observable } from 'rxjs';
import { ConditionalExpr } from '@angular/compiler';
import { TitleService } from '../services/title.service';
import { environment } from '../../../../environments/environment';

import liff from '@line/liff';
declare var window: any;
@Component({
    selector: 'app-skyjourney',
    templateUrl: './skyjourney.component.html',
    styleUrls: ['./skyjourney.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SkyjourneyComponent implements OnInit {
  
  @ViewChild('skyjourneyForm') skyjourneyForm: NgForm;
  
  regName = /^[-.a-zA-Z\sกขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮะัาำิีึืฺุูเแโใไ็่้๊๋์]+$/;
  regTel = /^0[1-9][0-9]{7,8}$/;
  
  model = model<any>({
    form: {
        firstName: { value: '', text: '' },
        lastName: { value: '', text: '' },
        idcard: { value: '', text: '' },
        mobile: { value: '', text: '' },
        lineId: { value: '', text: '' },
        chanelId: { value: '', text: '' },
        chanelLiffNumber: { value: '', text: '' },
        new_plateform_customer_flag: { value: null, text: '' }
    }
  });
  liffId: string;
  invalidInformation = signal<boolean>(false);
  profile: any
  lineId: string;

  complete = signal<string>('');
  loader: Observable<boolean>;

  constructor(
  private termsAndConditionService: TermsAndConditionService,
  // private router: Router,
  private route: ActivatedRoute,
  private lineNotificationService: LineNotificationService,
  private loaderService: LoaderService,
  private titleService: TitleService
  ) { }

  async ngOnInit() {
    this.titleService.setTitle('SKY JOURNEY');
    this.loader = this.loaderService.loadingObservable;
    this.loaderService.opendLoader();
    this.liffId = '1655827044-R3J51JaW';
    liff.init({ liffId: this.liffId })
    try {
      this.profile = await liff.getProfile();
      this.lineId = this.profile.userId;
    }
    catch(e){
      this.lineId = 'U92fc26c257f888f5aa4a6ce1690c16c1'
    };
    console.log(this.lineId);
    this.route.queryParams.subscribe(params => {
      console.log(params)
      if(params['session_ref']){
        this.complete.set('true');
        this.loaderService.closeLoader();
        // accept terms and condition
        // liff.sendMessages([
        //   {
        //     type: 'text',
        //     text: 'testetest'
        //   }]).then(function () {
        //     console.log('success');
        //   }).catch(function (error) {
        //     console.log('error');
        //   });
          
        //   const channel = {
        //       electronic_channel: 2,
        //       template_id: '124_18',
        //       channel_identity: this.lineId,
        //       line_account_token: 'cZ9CFrpZzB/Otb2ZnMW3E0Hto2BQgehvvDkrFtKURrdj8lX+TaBuMKLGYTEQ9fDVGLCYarlXkaFhpFuyfBGoC8tAcGlPJwDDL1nmhe4C+sExr/jtrXK06RxdiVqx1cnuCq/r9KYiy37xL+2IFvJ3QAdB04t89/1O/w1cDnyilFU=',
        //   } as Channel;

        //   console.log(channel);

        //   this.lineNotificationService.sendNotification(channel).subscribe(
        //     (result_line: any) => {
        //         console.log(result_line);
        //     }
        // );
      }
      else {
        this.complete.set('false');
        this.loaderService.closeLoader();
      }
    });
    // if (environment.log_level == 'debug') {
    //     window.vConsole = new window.VConsole();
    // }
    
    // if (liff.isLoggedIn() == false && liff.isInClient() == false) {
    //   liff.login({ redirectUri: window.location.href });
    // }
    if (environment.log_level == 'debug') {
        window.vConsole = new window.VConsole();
    }
  }

  async openTermsAndCondition() {
    // const channel = this.lineStateAction.channelStateInfo;
    // this.comCode = channel ? channel.comCode : '';
    // console.log(['terms-and-cond: ', channel]);
    console.log('term & condition')
    const session_ref = new Date().valueOf()
    let requestBody = {
      electronic_channel:2,
      channel_identity: '',// getProfile
      liff_url: window.location.href,// post back
      "session_ref": session_ref
    }
    this.termsAndConditionService.apiCheckTermsAndCondition(requestBody).subscribe(
      result => {
        this.loaderService.closeLoader();
        if (result && result.response_code == "40000") {
          if (result.payload.token_url) {
            // const identity = this.lineStateAction.identityStateInfo;
            // const customer = this.lineStateAction.customerStateInfo;
            // sessionStorage.setItem(session_ref + "channel", JSON.stringify(channel));
            // sessionStorage.setItem(session_ref + "identity", JSON.stringify(identity));
            // sessionStorage.setItem(session_ref + "customer", JSON.stringify(customer));
            window.location.href = result.payload.token_url;
          } else {
            // channel.termsAndCondition = {
            //   status: "skip"
            // } as TermsAndCondition
            // this.lineStateAction.sinkChannel.next(new SetChannelAction(channel));
            // this.router.navigate([`/register/line/${this.comCode}`], { relativeTo: this.route, queryParams: { "termsandcondition": "skip" } })
          }
        } else {
          // console.log('check terms and condition out of case')
          // channel.termsAndCondition = {
          //   status: "fail"
          // } as TermsAndCondition
          // this.lineStateAction.sinkChannel.next(new SetChannelAction(channel));
          // this.router.navigate([`/register/line/${this.comCode}/completed`], { relativeTo: this.route, queryParams: { "status": "fail" } })
        }
        console.log(result)
      },
      error => {
        // channel.termsAndCondition = {
        //   status: "fail"
        // } as TermsAndCondition
        // this.lineStateAction.sinkChannel.next(new SetChannelAction(channel));
        // console.log('check terms and condition error')
        // this.router.navigate([`/register/line/${this.comCode}/completed`], { relativeTo: this.route, queryParams: { "status": "fail", "code": "termsAndCondition error" } })
      }
    );
  }

  async onSubmit() {
    
    this.loaderService.opendLoader();
    // window.location.href = 'https://liff.line.me/1653929731-MO0lQNKe';
    // this.liffId = '1653929731-6gP2RlMY';
    // await liff.init({ liffId: this.liffId })
    // if (liff.isLoggedIn() == false) {
    //   liff.login({ redirectUri: window.location.href });
    // }
    // try {
    //   this.profile = await liff.getProfile();
    //   this.lineId = this.profile.userId;
    // }
    // catch(e){
    //   this.lineId = 'U92fc26c257f888f5aa4a6ce1690c16c1'
    //   console.log(e);
    // };
    // console.log(this.profile);
    this.openTermsAndCondition();
  }

  closeLiff() {
  //   liff.sendMessages([
  //   {
  //     type: 'text',
  //     text: ''
  //   }
  // ]);
    liff.closeWindow();
  }

  
  addClass(f: NgForm, field: string, type?: string, valueActive = '') {
    const iClass = [];
    if (f.form.get(field) && type !== 'msg') {
        if (f.form.get(field).invalid && (f.form.get(field).dirty || f.form.get(field).touched || f.submitted)) {
            iClass.push('uk-form-danger');
        } else if (f.form.get(field).valid && (f.form.get(field).dirty || f.form.get(field).touched || f.submitted)) {
            if (valueActive === '') {
                iClass.push('uk-form-success');
            } else if (f.form.get(field).value === valueActive) {
                iClass.push('uk-form-success');
            }
        }
    } else if (f.form.get(field) && type === 'msg') {
        if (f.form.get(field).invalid && (f.form.get(field).dirty || f.form.get(field).touched || f.submitted)) {
            iClass.push('uk-animation-fade');
        } else if (f.form.get(field).valid && (f.form.get(field).dirty || f.form.get(field).touched || f.submitted)) {
            iClass.push('uk-animation-reverse');
        }
    }

    return iClass;
  }

  validateIdCard = (value: string): Promise<boolean> => {

      if (value === '') { return Promise.resolve(false); }
      if (value != null && value.length < 13) { return Promise.resolve(false); }
      if (value != null && value.length === 13) {
          // STEP 1 - get only first 12 digits
          let idSum = 0;
          for (let i = 0; i < 12; i++) {
              // STEP 2 - multiply each digit with each index (reverse)
              // STEP 3 - sum multiply value together
              // tslint:disable-next-line: radix
              idSum += parseInt(value.charAt(i)) * (13 - i);
          }

          // STEP 4 - mod sum with 11
          const mod = idSum % 11;

          // STEP 5 - subtract 11 with mod, then mod 10 to get unit
          const check = (11 - mod) % 10;
          // STEP 6 - if check is match the digit 13th is correct
          // tslint:disable-next-line: radix
          if (check === parseInt(value.charAt(12))) {
              return Promise.resolve(true);
          }
          return Promise.resolve(false);
      }
      return Promise.resolve(true);
  }

  onKeyPress(params: any) {
      if (params.key === 'Backspace' || params.key === '.') {
          return true;
      } else if (!this.isKeyPressedNumeric(params)) {
          return false;
      }
  }

  private isKeyPressedNumeric(event: any): boolean {
      const inputVal = document.getElementById('mobile') as HTMLInputElement;
      let input = inputVal.value;
      input = input + event.key;
      if (input.length >= 2) {
          const txtVal = input;
          return /^((\d{1,10}))$/.test(txtVal);
      }
      const charCode = this.getCharCode(event);
      const charStr = event.key ? event.key : String.fromCharCode(charCode);
      return this.isCharNumeric(charStr);
  }

  private getCharCode(event: any): any {
      event = event || window.event;
      return (typeof event.which === 'undefined') ? event.keyCode : event.which;
  }

  private isCharNumeric(charStr: any): boolean {
      let validation = false;

      if (charStr === '.') {
          validation = !!/\./.test(charStr);
      } else {
          validation = !!/\d/.test(charStr);
      }
      return validation;
  }

  // onSubmit() {
  //   console.log('submit')
  // }
}
